import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyPrice", "annualPrice", "monthlyBtn", "annualBtn", "monthlyCheckout", "annualCheckout"]

  connect() {
    this.showMonthly()
  }

  showMonthly() {
    this.monthlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.annualPriceTargets.forEach(el => el.classList.add("hidden"))
    this.monthlyCheckoutTargets.forEach(el => el.classList.remove("hidden"))
    this.annualCheckoutTargets.forEach(el => el.classList.add("hidden"))

    this.monthlyBtnTarget.classList.add("active")
    this.annualBtnTarget.classList.remove("active")
  }

  showAnnual() {
    this.monthlyPriceTargets.forEach(el => el.classList.add("hidden"))
    this.annualPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.monthlyCheckoutTargets.forEach(el => el.classList.add("hidden"))
    this.annualCheckoutTargets.forEach(el => el.classList.remove("hidden"))

    this.annualBtnTarget.classList.add("active")
    this.monthlyBtnTarget.classList.remove("active")
  }
}

